<h2 class="popup-heading" mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="mat-typography">
    <mat-form-field appearance="fill">
        <mat-label>Event Name</mat-label>
        <input matInput placeholder="Enter Event Name" [(ngModel)]="show.custom_name" required>
    </mat-form-field>
		<mat-form-field appearance="fill" [class]="!env.showBrands ? 'hidden' : ''">
			<mat-label>Brand</mat-label>
			<mat-select disableRipple [(ngModel)]="show.brand_id">
				<mat-option [value]="0">Select Brand</mat-option>
				<mat-option *ngFor="let brand of brands" [value]="brand.id">{{ brand.name }}</mat-option>
			</mat-select>
		</mat-form-field>
        <p class="text-align">Brands allow you to customize the look and feel of the experience after the show code is entered. This
            includes a header and footer image, background and colors, and more... To learn more and to create / edit
            brands, goto My Brands in the menu.</p>
        <mat-card appearance="outlined" class="custom-card" style="margin-bottom: 20px;">
            <mat-card-header>
                <mat-card-title>Venue Location</mat-card-title>
                <p>This is the address of the physical venue where your show will take place.</p>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field appearance="fill" class="single-field">
                    <mat-label>Address Line 1</mat-label>
                    <textarea matInput [(ngModel)]="show.address1"></textarea>
                </mat-form-field>
                <mat-form-field appearance="fill" class="single-field">
                    <mat-label>Address Line 2</mat-label>
                    <textarea matInput [(ngModel)]="show.address2"></textarea>
                </mat-form-field>
                <mat-form-field appearance="fill" class="single-field">
                    <mat-label>City</mat-label>
                    <input matInput [(ngModel)]="show.city">
                </mat-form-field>
                <mat-form-field appearance="fill" class="single-field">
                    <mat-label>State</mat-label>
                    <input matInput [(ngModel)]="show.state">
                </mat-form-field>
                <mat-form-field appearance="fill" class="single-field">
                    <mat-label>Country</mat-label>
                    <input matInput [(ngModel)]="show.country">
                </mat-form-field>
            </mat-card-content>
          </mat-card>
            
        <div class="show-date" appearance="fill">
            <h4 class="text">Show Date</h4>
            <mat-form-field appearance="fill">
                <mat-label>Choose Show date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="show.show_date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
    <!-- <mat-form-field>
        <input matInput type="time" #timeInput (blur)="valdiateTime()" placeholder="Choose Show Time" [(ngModel)]="show.show_time">
    </mat-form-field> -->
    <div class="show-time" appearance="fill">
        <h4 class="text">Show Time</h4>
        <mat-form-field class="half-width">
            <mat-label>Hours</mat-label>
            <mat-select [(ngModel)]="show_hours">
                <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="half-width">
            <mat-label>Minutes</mat-label>
            <mat-select [(ngModel)]="show_minutes">
                <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="time-zone" appearance="fill">
        <h4 class="text">Time Zone</h4>
        <mat-form-field appearance="fill">
            <mat-label>Timezone</mat-label>
            <mat-select disableRipple [(ngModel)]="show.show_timezone">
                <mat-option [value]="">Select Timezone</mat-option>
                <mat-option *ngFor="let timezone of timezones" [value]="timezone.diff">
                  <span class="timezone-option" [title]="timezone.diff">
                    {{ timezone.name + " (UTC " + timezone.diff + ")" }}
                  </span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <mat-form-field appearance="fill">
        <mat-label>Date and Time Override Text</mat-label>
        <input matInput placeholder="Enter Date and Time Override Text" [(ngModel)]="show.datetime_text">
    </mat-form-field>
    <p class="text-align">Replace the date and time on the app and website show page with this text. By populating this field, you won't affect any change to functionality associated to the show's official show date and show time.</p>
    <div>
        <mat-checkbox class="add-smpte-chkbx" [(ngModel)]="show.start_automatically" (change)="onAutoStartChange($event)">Start show automatically at this time
        </mat-checkbox>
        <small style="display: block; margin-left: 38px;">The show will start automatically at the above specified date and time within selected time zone. We suggest you test this functionality based on your current time zone as a dry run to ensure everything is set correctly.</small><br>
    </div>
    <div>
        <mat-checkbox class="add-smpte-chkbx" [(ngModel)]="show.looping">Loop Soundtrack
        </mat-checkbox>
        <small style="display: block; margin-left: 38px;">The soundtrack will continue to loop (play back to back) for the listener. It is recommended to use this feature in combination with the start automatically feature.</small><br>
    </div>
    
    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Description</mat-label>
        <textarea matInput [(ngModel)]="show.description" rows="10"></textarea>
    </mat-form-field>
    
    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Website URL (make sure to include http:// or https://)</mat-label>
        <input matInput [(ngModel)]="show.website_url">
    </mat-form-field>
    <mat-form-field appearance="fill" class="single-field">
        <mat-label>SMPTE Offset (s)</mat-label>
        <input type="number" matInput [(ngModel)]="show.smpte_offset" [disabled]="show.audio_file_info && show.audio_file_info.timecode_channel=='none'">
    </mat-form-field>
    <p class="smpt-offset-description" *ngIf="show.audio_file_info && show.audio_file_info.timecode_channel=='none'">This field is only supported for shows with SMPTE time code.</p>
    <p class="smpt-offset-description" *ngIf="show.audio_file_info && show.audio_file_info.timecode_channel=='right'">This will add the entered number of seconds (up to 300) as silence to the beginning of the operator played soundtrack. This same number of seconds will delay the playback on the audience played soundtrack. By having this offset, it allows the operator to have a pre-roll of SMPTE before the show starts.</p>
    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Extra Button Label (up to 15 characters)</mat-label>
        <input type="text" matInput [(ngModel)]="show.extra_button_text" maxlength="15">
    </mat-form-field>
    
    <mat-form-field appearance="fill" class="single-field">
        <mat-label>Extra Button URL (make sure to include http:// or https://)</mat-label>
        <input type="text" matInput [(ngModel)]="show.extra_button_url">
    </mat-form-field>
    <div class="editor-field">
        <label>Terms & Conditions</label>
        <angular-editor [(ngModel)]="show.terms" [config]="editorConfig"></angular-editor>
    </div>
    
    
    <!--<mat-form-field appearance="fill">
        <mat-label>Video Before Show</mat-label>
        <input matInput [(ngModel)]="show.video_before_show">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Video After Show</mat-label>
        <input matInput [(ngModel)]="show.video_after_show">
    </mat-form-field>-->
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="cancel-popup" mat-stroked-button (click) = "close()">Cancel</button>
    <button class="popup-save" mat-flat-button [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" (click) = "save()" cdkFocusInitial [disabled]="processing">
			<mat-icon *ngIf="processing">
				<mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
			</mat-icon>
			Save
		</button>
  </mat-dialog-actions>
